<div class="ContentGroupListing">
  <div class="ContentGroupListing-header d-flex flex-row">
    <div
      class="ContentGroupListing-header-title flex-grow-1 d-flex flex-row align-items-center">
      <div class="Breadcrumbs">
        <div class="Breadcrumbs-items">
          <a [routerLink]="['/contents']"
            ><mat-icon class="Breadcrumbs-icon back"
              >keyboard_backspace</mat-icon
            ></a
          >
          <a class="Breadcrumbs-item" [routerLink]="['/contents']"
            >Content Group</a
          >
        </div>
      </div>
      <app-svg-renderer
        class="ms-3 mt-1 cursor-pointer"
        [svg]="'Yellow Plane'"
        (click)="onInfoImageClick()"></app-svg-renderer>
    </div>
  </div>
  <div class="ContentGroupListing-table">
    <app-table
      *ngIf="tableReady"
      [filterGroups]="tableFilterGroups"
      [columns]="tableColumns"
      [dataSource]="dataSource"
      [dataSourceParams]="tableDataSourceParams"></app-table>
  </div>
</div>
